import PropTypes from "prop-types"
import React from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import { connect } from "react-redux"

// Import Routes all
import {
  frontendRoutes,
  userRoutes,
  authRoutes,
  adminRoutes,
} from "./routes/allRoutes"

// Import all middleware
import Usermiddleware from "./routes/middleware/Usermiddleware"
import Adminmiddleware from "./routes/middleware/Adminmiddleware"

// layouts Format
import NonAuthLayout from "./components/NonAuthLayout"
import "./assets/styles.scss"
import "./assets/scss/theme.scss"

import ScrollToTop from "components/Common/ScrollToTop"

const NotFound = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      fontFamily: "Inter, Arial, sans-serif",
      background: "#FEE6F7",
      textAlign: "center",
      padding: "2rem",
    }}
  >
    <h1 style={{ color: "#880356", fontSize: "4rem", marginBottom: "0.5rem" }}>
      404
    </h1>
    <p style={{ color: "#505050", fontSize: "1.2rem", marginBottom: "2rem" }}>
      Page not found
    </p>
    <a
      href="/"
      style={{
        background: "#880356",
        color: "#fff",
        padding: "0.75rem 2rem",
        borderRadius: "8px",
        textDecoration: "none",
        fontSize: "1rem",
      }}
    >
      Go to Home
    </a>
  </div>
)

const App = () => {
  return (
    <React.Fragment>
      <ScrollToTop />
      <Routes>
        <Route>
          {authRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {userRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<Usermiddleware>{route.component}</Usermiddleware>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {adminRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<Adminmiddleware>{route.component}</Adminmiddleware>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {frontendRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={route.component}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        {/* Catch-all: 404 page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
